/** Enhance the global header without making navigation depend on JavaScript. */
export function initializeHeader() {
  const header = document.querySelector('#masthead');
  if (!header) return;

  const sections = [...document.querySelectorAll('#primary > section[id]')];
  const menus = [...document.querySelectorAll('.header-navigation, .footer-navigation')].map((menu) =>
    [...menu.querySelectorAll('a[href]')].map((link) => {
      const url = new URL(link.href);
      return { link, hash: url.origin === location.origin && url.pathname === location.pathname && url.search === location.search ? url.hash : '' };
    })
  );
  const updateScroll = () => {
    header.dataset.scrolled = String(window.scrollY > 24);
    // Use every section, not only linked sections: unlinked content must clear the highlight.
    const anchorOffset = Number.parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
    const readingLine = Math.max(header.getBoundingClientRect().bottom, anchorOffset) + 32;
    const current = sections.find((section) => {
      const bounds = section.getBoundingClientRect();
      return bounds.top <= readingLine && bounds.bottom > readingLine;
    });
    for (const menu of menus) {
      let marked = false;
      for (const { link, hash } of menu) {
        if (!hash && !sections.length) continue;
        if (!marked && current && hash === `#${encodeURIComponent(current.id)}`) {
          link.setAttribute('aria-current', 'location');
          marked = true;
        } else {
          link.removeAttribute('aria-current');
        }
      }
    }
  };
  updateScroll();
  window.addEventListener('scroll', updateScroll, { passive: true });
  window.addEventListener('resize', updateScroll);
  window.addEventListener('pageshow', updateScroll);
  window.addEventListener('hashchange', updateScroll);

  const toggle = document.querySelector('#menu-toggle');
  const panel = document.querySelector('#header-panel');
  if (!toggle || !panel) return;

  const desktop = window.matchMedia('(min-width: 1024px)');
  const close = () => {
    toggle.setAttribute('aria-expanded', 'false');
    panel.inert = !desktop.matches;
  };
  const syncViewport = () => {
    const focusWasOnToggle = document.activeElement === toggle;
    toggle.hidden = desktop.matches;
    // Never leave keyboard focus inside content hidden by a breakpoint change.
    if (!desktop.matches && panel.contains(document.activeElement)) toggle.focus();
    close();
    if (desktop.matches && focusWasOnToggle) panel.querySelector('a')?.focus();
  };

  header.dataset.enhanced = 'true';
  syncViewport();
  desktop.addEventListener('change', syncViewport);
  toggle.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(open));
    panel.inert = !open;
  });
  header.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
      close();
      toggle.focus();
    }
  });
  panel.addEventListener('click', (event) => {
    if (event.target instanceof Element && event.target.closest('a')) close();
  });
  header.addEventListener('focusout', (event) => {
    if (!header.contains(event.relatedTarget)) close();
  });
  document.addEventListener('click', (event) => {
    if (!header.contains(event.target)) close();
  });
}
